/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFBTechsAggregatedRecord } from './CRSFBTechsAggregatedRecord';
import {
    CRSFBTechsAggregatedRecordFromJSON,
    CRSFBTechsAggregatedRecordFromJSONTyped,
    CRSFBTechsAggregatedRecordToJSON,
} from './CRSFBTechsAggregatedRecord';
import type { CRSFTechSourceType } from './CRSFTechSourceType';
import {
    CRSFTechSourceTypeFromJSON,
    CRSFTechSourceTypeFromJSONTyped,
    CRSFTechSourceTypeToJSON,
} from './CRSFTechSourceType';
import type { CRSFTechsAggregatedRecord } from './CRSFTechsAggregatedRecord';
import {
    CRSFTechsAggregatedRecordFromJSON,
    CRSFTechsAggregatedRecordFromJSONTyped,
    CRSFTechsAggregatedRecordToJSON,
} from './CRSFTechsAggregatedRecord';
import type { CRSFWTechsAggregatedRecord } from './CRSFWTechsAggregatedRecord';
import {
    CRSFWTechsAggregatedRecordFromJSON,
    CRSFWTechsAggregatedRecordFromJSONTyped,
    CRSFWTechsAggregatedRecordToJSON,
} from './CRSFWTechsAggregatedRecord';

/**
 * 
 * @export
 * @interface TechnologiesInner
 */
export interface TechnologiesInner {
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    asset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechnologiesInner
     */
    category: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TechnologiesInner
     */
    created: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechnologiesInner
     */
    cves: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TechnologiesInner
     */
    data: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof TechnologiesInner
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    module: string;
    /**
     * 
     * @type {number}
     * @memberof TechnologiesInner
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    protocol: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    se_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TechnologiesInner
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    source_asset: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    tech_key: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    tech_name: string;
    /**
     * 
     * @type {CRSFTechSourceType}
     * @memberof TechnologiesInner
     */
    tech_source?: CRSFTechSourceType;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner
     */
    cpe: string;
}

/**
 * Check if a given object implements the TechnologiesInner interface.
 */
export function instanceOfTechnologiesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "cves" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "module" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "protocol" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "source_asset" in value;
    isInstance = isInstance && "tech_key" in value;
    isInstance = isInstance && "tech_name" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "cpe" in value;

    return isInstance;
}

export function TechnologiesInnerFromJSON(json: any): TechnologiesInner {
    return TechnologiesInnerFromJSONTyped(json, false);
}

export function TechnologiesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TechnologiesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'created': json['created'],
        'cves': json['cves'],
        'data': json['data'],
        'found': json['found'],
        'module': json['module'],
        'port': json['port'],
        'process_id': json['process_id'],
        'protocol': json['protocol'],
        'se_version': !exists(json, 'se_version') ? undefined : json['se_version'],
        'shared': json['shared'],
        'source': json['source'],
        'source_asset': json['source_asset'],
        'tech_key': json['tech_key'],
        'tech_name': json['tech_name'],
        'tech_source': !exists(json, 'tech_source') ? undefined : CRSFTechSourceTypeFromJSON(json['tech_source']),
        'version': json['version'],
        'cpe': json['cpe'],
    };
}

export function TechnologiesInnerToJSON(value?: TechnologiesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'created': value.created,
        'cves': value.cves,
        'data': value.data,
        'found': value.found,
        'module': value.module,
        'port': value.port,
        'process_id': value.process_id,
        'protocol': value.protocol,
        'se_version': value.se_version,
        'shared': value.shared,
        'source': value.source,
        'source_asset': value.source_asset,
        'tech_key': value.tech_key,
        'tech_name': value.tech_name,
        'tech_source': CRSFTechSourceTypeToJSON(value.tech_source),
        'version': value.version,
        'cpe': value.cpe,
    };
}

